import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import $ from "jquery";
import { MDCDataTable } from '@material/data-table';
import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';
import { MDCTabBar } from '@material/tab-bar';
import ServicesTab from './AdminPageTabs/ServicesTab' 
import NiceTGTab from './AdminPageTabs/NiceTGTab' 
import UsersTab from './AdminPageTabs/UsersTab' 
import DepositsTab from './AdminPageTabs/DepositsTab' 
import OrdersTab from './AdminPageTabs/OrdersTab' 
import StatsTab from './AdminPageTabs/StatsTab' 

var snackbar

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected || 0
    }
  }

  getInitialState() {
    return {
      selected: this.props.selected || 0
    }
  }

  handleChange(index) {
    this.setState({ selected: index })
  }

  componentDidMount() {
    new MDCTabBar(document.querySelector("#adminTabs"))
    this.setState(this.getInitialState())
  }

  render() {
    return <div>
      <div className="mdc-tab-bar" role="tablist" id="adminTabs">
        <div className="mdc-tab-scroller">
          <div className="mdc-tab-scroller__scroll-area">
            <div className="mdc-tab-scroller__scroll-content">
              {this.props.children.map((elem, index) => {
                let buttonStyle = index == this.state.selected ? 'mdc-tab mdc-tab--active' : 'mdc-tab'
                let spanStyle = index == this.state.selected ? 'mdc-tab-indicator mdc-tab-indicator--active' : 'mdc-tab-indicator';
                return <button className={buttonStyle} role="tab" aria-selected="false" tabindex="-1" key={index} onClick={this.handleChange.bind(this, index)}>
                  <span className="mdc-tab__content">
                    <span className="mdc-tab__icon" aria-hidden="true"><i className={elem.props.icon}></i> </span>
                    <span className="mdc-tab__text-label">{elem.props.title}</span>
                  </span>
                  <span className={spanStyle}>
                    <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span className="mdc-tab__ripple"></span>
                </button>
              })}
            </div>
          </div>
        </div>
      </div>
      <div>{this.props.children[this.state.selected]}</div>
    </div>
  }


}

class Panel extends React.Component {
  render() {
    return <div>{this.props.children}</div>
  }
}

class AdminSnackbar extends React.Component {
  componentDidMount() {
    snackbar = new MDCSnackbar(document.querySelector('#adminSnackbar'));
    snackbar.openText = function (text) {
      document.querySelector("#adminSnackbarText").innerHTML = text
      snackbar.open()
    }
  }
  render(props) {
    return <div class="mdc-snackbar" id="adminSnackbar">
      <div class="mdc-snackbar__surface">
        <div class="mdc-snackbar__label" role="status" aria-live="polite" id="adminSnackbarText"></div>
        <div class="mdc-snackbar__actions">
          <button type="button" class="mdc-button mdc-snackbar__action">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label">Закрыть</span>
          </button>
        </div>
      </div>
    </div>
  }
}

class AdminPage extends React.Component {
  constructor(props) {
    super(props)
  }

  render(props) {
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <main className="main-content" id="main-content">
        <link href="css/admin.css" rel="stylesheet"></link>
        <AdminSnackbar />
        <h2 className="pageHeader">Админка</h2>
        <Tabs selected={4}>
          <Panel title="Пользователи" icon="fas fa-user"><UsersTab /></Panel>
          <Panel title="Продвижение" icon="fas fa-chart-line"><ServicesTab /></Panel>
          <Panel title="NiceTG" icon="fas fa-robot"><NiceTGTab /></Panel>
          <Panel title="Пополнения" icon="fas fa-credit-card"><DepositsTab /></Panel>
          <Panel title="Заказы" icon="fas fa-shopping-cart"><OrdersTab /></Panel>
          <Panel title="Статистика" icon="fas fa-chart-area"><StatsTab /></Panel>
        </Tabs>
      </main>
    </div>
  }
}

export default AdminPage